import { BRANCHES } from "../lib/branches";
import { MapPin, Phone, Clock, Star } from "lucide-react";

export default function Locations() {
  return (
    <div data-testid="locations-page">
      <section className="bg-bone border-b border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
          <p className="overline text-terracotta mb-4">Find a Church</p>
          <h1 className="font-heading font-black text-5xl sm:text-6xl tracking-tighter text-olive leading-[0.95] max-w-3xl">
            A <em className="italic font-light text-terracotta">family</em> across Mpumalanga.
          </h1>
          <p className="mt-6 text-ink/70 text-lg max-w-2xl">
            We have branches across South Africa — come worship with us at the location nearest
            to you.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BRANCHES.map((b) => (
            <article key={b.id} className="bg-white border border-border hover:border-olive hover:shadow-lg hover:-translate-y-1 transition-all" data-testid={`branch-${b.id}`}>
              <div className="p-8">
                <div className="flex items-center justify-between">
                  <p className="overline text-terracotta">{b.role}</p>
                  {b.role === "Headquarters" && (
                    <span className="inline-flex items-center gap-1 bg-olive text-bone px-3 py-1 text-xs font-bold">
                      <Star size={10} fill="currentColor" /> HQ
                    </span>
                  )}
                </div>
                <h3 className="font-heading font-black text-3xl text-olive tracking-tight mt-3">{b.name}</h3>
                <p className="text-sm text-muted_ink mt-1">{b.city}</p>

                <div className="mt-6 pt-6 border-t border-border space-y-3">
                  <div className="flex items-start gap-2 text-sm text-ink/80">
                    <MapPin size={14} className="mt-0.5 text-terracotta shrink-0" />
                    {b.address}
                  </div>
                  <div className="flex items-start gap-2 text-sm text-ink/80">
                    <Phone size={14} className="mt-0.5 text-terracotta shrink-0" />
                    <a href={`tel:${b.phone.replace(/\s/g, "")}`} className="hover:text-terracotta">{b.phone}</a>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-border">
                  <p className="overline text-olive mb-3 flex items-center gap-2"><Clock size={12} /> Service Times</p>
                  <ul className="space-y-2">
                    {b.times.map((t, i) => (
                      <li key={i} className="flex items-center justify-between text-sm">
                        <span className="text-ink">
                          <span className="font-semibold">{t.day}</span> · <span className="text-muted_ink">{t.label}</span>
                        </span>
                        <span className="font-mono text-terracotta font-semibold">{t.time}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
